import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '@unicup-ticketing/auth';
import { defer, from, iif, of, switchMap } from 'rxjs';

export const LoginIfNotAuthenticated: CanActivateFn = (
  route,
  state,
  router = inject(Router),
  authService = inject(AuthService),
) => {
  return authService.isAuthenticated().pipe(
    switchMap(authenticated =>
      iif(
        () => authenticated,
        of(true),
        defer(() => from(router.navigateByUrl(`/login?reqUrl=${state.url}`))),
      ),
    ),
  );
};
